
import { Header } from "@/components/layout/Header";
import { Card, CardContent } from "@/components/ui/card";

const Examples = () => {
  // Example data for before/after comparisons using local photos
  const examples = [
    {
      id: 1,
      title: "Obývací pokoj",
      description: "Prázdný prostor proměněný v elegantní obývací pokoj s moderním nábytkem",
      beforeImage: "/images/examples/livingroom_before.jpeg",
      afterImage: "/images/examples/livingroom_after.jpeg"
    },
    {
      id: 2,
      title: "Ložnice",
      description: "Čistá a jednoduchá ložnice s neutrálními tóny a příjemnou atmosférou",
      beforeImage: "/images/examples/bedroom_before.jpeg",
      afterImage: "/images/examples/bedroom_after.jpg"
    },
    {
      id: 3,
      title: "Jídelna",
      description: "Prázdná jídelna proměněná v útulný prostor pro rodinné stolování",
      beforeImage: "/images/examples/dinningroom_before.jpeg",
      afterImage: "/images/examples/dinningroom_after.jpeg"
    },
    {
      id: 4,
      title: "Pracovna",
      description: "Profesionální pracovní prostor vytvořený v jakékoli místnosti",
      beforeImage: "/images/examples/workroom_before.jpeg",
      afterImage: "/images/examples/workroom_after.jpg"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 bg-white">
        <section className="py-12 md:py-20">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Ukázky virtual staging
              </h1>
              <p className="text-lg text-gray-600">
                Podívejte se na proměnu prázdných prostorů v krásně zařízené interiéry.
                Naše virtual staging technologie vytváří realistické a profesionální výsledky.
              </p>
            </div>
            
            <div className="space-y-16">
              {examples.map((example) => (
                <div key={example.id} className="bg-gray-50 rounded-lg p-6 md:p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">{example.title}</h2>
                  <p className="text-gray-600 mb-6">{example.description}</p>
                  
                  <div className="grid md:grid-cols-2 gap-4 md:gap-8">
                    <Card>
                      <CardContent className="p-0">
                        <div className="aspect-video relative">
                          <img 
                            src={example.beforeImage} 
                            alt={`Před: ${example.title}`}
                            className="w-full h-full object-cover rounded-t-lg"
                          />
                          <div className="absolute top-2 left-2 bg-black/70 text-white px-3 py-1 text-sm rounded">
                            Před
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card>
                      <CardContent className="p-0">
                        <div className="aspect-video relative">
                          <img 
                            src={example.afterImage} 
                            alt={`Po: ${example.title}`}
                            className="w-full h-full object-cover rounded-t-lg" 
                          />
                          <div className="absolute top-2 left-2 bg-brand-indigo text-white px-3 py-1 text-sm rounded">
                            Po
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="mt-16 text-center">
              <p className="text-lg text-gray-600 mb-6">
                Připraveni proměnit své vlastní prostory?
              </p>
              <a href="/register" className="inline-block bg-brand-indigo text-white px-8 py-3 rounded-md hover:bg-brand-indigo/90 transition-colors">
                Začít
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Examples;
